// extracted by mini-css-extract-plugin
module.exports =  {"reportName":"reportName_IIMnvzoI","reportNameSubText":"reportNameSubText_q2p4AS6j"};